var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckSolidClean(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 54 54",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.2682 0.333008C12.5482 0.333008 0.601562 12.2797 0.601562 26.9997C0.601562 41.7197 12.5482 53.6663 27.2682 53.6663C41.9882 53.6663 53.9349 41.7197 53.9349 26.9997C53.9349 12.2797 41.9882 0.333008 27.2682 0.333008ZM20.0416 38.4397L10.4682 28.8663C9.42823 27.8263 9.42823 26.1463 10.4682 25.1063C11.5082 24.0663 13.1882 24.0663 14.2282 25.1063L21.9349 32.7863L40.2816 14.4397C41.3216 13.3997 43.0016 13.3997 44.0416 14.4397C45.0816 15.4797 45.0816 17.1597 44.0416 18.1997L23.8016 38.4397C22.7882 39.4797 21.0816 39.4797 20.0416 38.4397Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckSolidClean);
export default __webpack_public_path__ + "static/media/check_solid_clean.0be59a87b1f569eb32ad8310e5f34dc7.svg";
export { ForwardRef as ReactComponent };